import { FunctionComponent, PropsWithChildren } from 'react';

import { useAppSelector } from '../../../../../../../store/hooks';
import { AllReviewsFiltersProps } from '../types/all-reviews-filters-props';

const withFilterValues = (
  Component: FunctionComponent<AllReviewsFiltersProps>
): FunctionComponent<AllReviewsFiltersProps> => {
  return (props: PropsWithChildren<AllReviewsFiltersProps>) => {
    const filterValues = useAppSelector(state => state.reviews.filters.header);
    return <Component {...props} filterValues={filterValues} />;
  };
};

export default withFilterValues;
